import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractService } from './abstract.service';
import { LoginService } from './login.service';
import { HabilEmpresarialRotina } from '../models/he-produto';

@Injectable({
  providedIn: 'root'
})
export class HabilEmpresarialRotinaService extends AbstractService<HabilEmpresarialRotina> {
  titulo: string = "HE - Rotinas";

  endpoint(): string {
    return "registro/he-rotina";
  }
  rotina(): string {
    return "HE_PRODUTOS";
  }
  colunas(): any[] {
    return [
      { header: "Código", field: "id" },
      { header: "Nome", field: "nome" },
      { header: "Categoria", field: "categoria" },
      { header: "Base36", field: "codigo" }
    ]
  }
  private uri(ehLista?: boolean): string {
    let ret = "/adm/he-rotina";
    if (ehLista) {
      return ret;
    }
    return ret + "/cadastro";
  }

  novo(selection?: any) {
    AbstractService.readonly = false;
    this.router.navigate([this.uri()])
  }
  abrir(obj: HabilEmpresarialRotina) {
    AbstractService.readonly = true;
    this.router.navigate([this.uri()], { queryParams: { id: obj.id } });
  }
  edit(obj: HabilEmpresarialRotina) {
    AbstractService.readonly = false;
    this.router.navigate([this.uri()], { queryParams: { id: obj.id } });
  }
  routeLista() {
    return this.uri(true);
  }

  constructor(public http: HttpClient, public loginService: LoginService, private router: Router) {
    super(http, loginService);
  }
}
